import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import * as store from 'store';

export class CacheableTranslateHttpLoader implements TranslateLoader {

  constructor(private http: HttpClient,
              public prefix: string = '/assets/i18n/',
              public suffix: string = '.json') {
  }

  getTranslation(lang: string): Observable<any> {
    return this.http.get(`${this.prefix}${lang}${this.suffix}`).pipe(
      map(data => {
        this.save(lang, data);
        return data;
      }),
      catchError((err: any) => {
        return Observable.of(this.load(lang));
      })
    );
  }

  private load(lang: string) {
    return store.get(`lang.${lang}`)
  }

  private save(lang: string, data: any) {
    store.set(`lang.${lang}`, data)
  }

}



// WEBPACK FOOTER //
// ./src/app/providers/translation.http.loader.ts